import React from "react";

/**
 * OptimizedImage automatically:
 * - Uses modern formats (WebP/AVIF) via Cloudinary
 * - Serves responsive images with srcSet
 * - Lazy loads non-LCP images
 *
 * Props:
 *  - src: Cloudinary image URL (without format/width params)
 *  - alt: alt text
 *  - widths: array of widths for srcSet (default [380, 768, 1200])
 *  - sizes: string for sizes attribute (default "100vw")
 *  - className: optional CSS class
 *  - isLCP: true if this is your Largest Contentful Paint image
 */
const OptimizedImage = ({ src, alt, widths = [380, 768, 1200], sizes = "100vw", isLCP = false, style }) => {
  // Split at "upload/" so we can insert transformations after it
  const [base, rest] = src.split("/upload/");
  // rest includes version if present
  const srcSet = widths
    .map((w) => `${base}/upload/w_${w},f_auto,q_auto/${rest} ${w}w`)
    .join(", ");
  const defaultSrc = `${base}/upload/w_${widths[0]},f_auto,q_auto/${rest}`;

  return (
    <img
      src={defaultSrc}
      srcSet={srcSet}
      sizes={sizes}
      alt={alt}
      loading={isLCP ? "eager" : "lazy"}
      fetchpriority={isLCP ? "high" : "auto"}
      style={style}
    />
  );
};

export default OptimizedImage;
